"use strict";
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalArray = void 0;
function equalArray(x, y) {
    return x.length === y.length && x.every((a, i) => y[i] === a);
}
exports.equalArray = equalArray;
//# sourceMappingURL=index.js.map